import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { getSingleProductbystatus } from "../../../actions/singleProductAction";
import { getAllBrand } from "../../../actions/Inventory/brandAction";
import { getAllCategory } from "../../../actions/categoryAction";
import RenderTable from "./RenderTable";
import ActiveRenderTable from "./ActiveRendertable";
import {
  Skeleton,
  Tabs,
  Row,
  Col,
  AutoComplete,
  Divider,
  TreeSelect,
  Spin,
  Checkbox,
  Space,
  Select,
} from "antd";
import { LoadingOutlined } from "@ant-design/icons";
const { TabPane } = Tabs;
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
const { Option } = Select;

const ProductList = ({
  getSingleProductbystatus,
  
  List,
  updatelist,
  setUpdatelist,
  setselectedproduct,
  totalitems,
  getAllCategory,
  categoryList,
  getAllBrand,
  brands,
}) => {
  const [data, setdata] = useState(false);
  const [products, setproducts] = useState(false);
  const loading = useRef(true);
  const pageno = useRef(1);
  const page_size = useRef(10);
  const keytab = useRef(true);
  const keyward = useRef("");
  const searchCategory = useRef("");
  const searchBrand = useRef("");
  const [reload, setreload] = useState(false);
  const searchProductDiscount = useRef("");

  const onChange = (event) => {
    if (event.keyCode == 13) {
      pageno.current = 1;
      keyward.current = event.target.value;
      setreload(true);
    }
  };

  function callback(key) {
    console.log(key);
    pageno.current = 1;
    if (key == 1) {
      keytab.current = true;
    } else {
      keytab.current = false;
    }
    setreload(true);
  }

  useEffect(() => {
    getAllCategory();
    getAllBrand();
    getSingleProductbystatus(
      keytab.current,
      keyward.current,
      searchCategory.current,
      "",
      "",
      pageno.current,
      page_size.current,
      // searchProductDiscount.current ? 1 : ""
      searchProductDiscount.current, 
      searchBrand.current,
    ).then((result) => {
      setproducts(result);
      setUpdatelist(true);
      setdata(true);
      setreload(false);
    });
  }, [reload]);

  // const onProductDiscountChange = (e) => {
  //   searchProductDiscount.current = e.target.checked;
  //   pageno.current = 1;
  //   setreload(true);
  // };
  const onProductDiscountChange = (e) => {  // Add this function
    if (e.target.checked) {
      searchProductDiscount.current = 0;
    } else {
      searchProductDiscount.current = "";
    }
    setreload(true);
  };

  const rendertable = () => {
    if (reload) {
      return (
        <>
          <span style={{ marginTop: "30px" }}>
            <Spin indicator={antIcon} /> loading
          </span>
        </>
      );
    }
  };

  if (data) {
    return (
      <>
        <Row>
          <Col span={10}>
            <h3>Enter product title for instant Search</h3>
            <AutoComplete
              placeholder="input search text"
              onKeyUp={onChange}
              style={{ width: "100%" }}
            />
          </Col>
          <Col span={3} offset={0}>
          <h3>Brand</h3>
          <Select
            placeholder="Select Brand"
            style={{ width: "100%" }}
            allowClear
            optionFilterProp="children"
            showSearch
            filterOption={(input, option) =>
              ((option && option.children) ? option.children.toLowerCase() : '')
                .includes(input.toLowerCase())
            }
            filterSort={(optionA, optionB) =>
              ((optionA && optionA.children) ? optionA.children.toLowerCase() : '')
                .localeCompare(
                  (optionB && optionB.children) ? optionB.children.toLowerCase() : ''
                )
            }
            onChange={(value) => {
              pageno.current = 1;
              searchBrand.current = value;
              // setloading(true);
              setreload(!reload);
            }}
          >
            <Option value="">All</Option>
            {brands.map((brand) => (
              <Option key={brand.id} value={brand.id}>
                {brand.name}
              </Option>
            ))}
          </Select>
        </Col>
          <Col span={5} offset={1}>
            <h3>Category</h3>

            <TreeSelect
              style={{ width: "100%" }}
              treeData={categoryList}
              onChange={(value) => {
                pageno.current = 1;
                searchCategory.current = value;
                setreload(true);
              }}
            />
          </Col>
          <Col offset={1}>
            <Row style={{ color: "white" }}>
              .
            </Row>
            <Row style={{ color: "white" }}>
              .
            </Row>

            {/* <Row>
              <Space direction="vertical">
                <Checkbox  onChange={onProductDiscountChange} ><h3>Show Discounted Products</h3></Checkbox>
              </Space>
            </Row> */}


          </Col>
          {/* <Col offset={1}>{rendertable()}</Col> */}
        </Row>
        <Divider />
        <Spin spinning={reload}>
          <Tabs defaultActiveKey="1" onChange={callback}>
            <TabPane tab="Active Products" key="1">
              <ActiveRenderTable
                List={products.results}
                setUpdatelist={setUpdatelist}
                setselectedproduct={setselectedproduct}
                pageno={pageno}
                page_size={page_size}
                totalitems={totalitems}
                setreload={setreload}
              />
            </TabPane>
            <TabPane tab="Inactive Products" key="2">
              <RenderTable
                List={products.results}
                setUpdatelist={setUpdatelist}
                setselectedproduct={setselectedproduct}
                pageno={pageno}
                page_size={page_size}
                totalitems={totalitems}
                setreload={setreload}
              />
            </TabPane>
          </Tabs>
        </Spin>
      </>
    );
  } else {
    return (
      <>
        <Skeleton active />
        <Skeleton active />
      </>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    List: state.singleProduct.sinleproductlist.results,
    totalitems: state.singleProduct.sinleproductlist.count,
    categoryList: state.category.categorylist,
    brands: state.brand.brandlist,

  };
};

export default connect(mapStateToProps, {
  getSingleProductbystatus,
  getAllCategory,
  getAllBrand,
})(ProductList);
